import React, { useState, useEffect, useRef } from 'react';
import { useDebounce } from '../../hooks/useDebounce';
import * as api from '../../services/api';

export default function ImporterFilter({ value, onChange }) {
  const [input, setInput] = useState(value || '');
  const [suggestions, setSuggestions] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const debounced = useDebounce(input, 300);
  const ref = useRef(null);

  useEffect(() => {
    if (debounced && debounced.length >= 2) {
      api.suggestImporters(debounced, 10)
        .then(data => {
          setSuggestions(data || []);
          setShowSuggestions(data && data.length > 0);
        })
        .catch(() => setSuggestions([]));
    } else {
      setSuggestions([]);
      setShowSuggestions(false);
    }
  }, [debounced]);

  useEffect(() => {
    function handleClick(e) {
      if (ref.current && !ref.current.contains(e.target)) setShowSuggestions(false);
    }
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, []);

  const handleSelect = (name) => {
    setInput(name);
    onChange(name);
    setShowSuggestions(false);
  };

  const handleChange = (e) => {
    setInput(e.target.value);
    if (!e.target.value) onChange('');
  };

  const handleBlur = () => {
    setTimeout(() => {
      if (input !== value) onChange(input);
    }, 200);
  };

  return (
    <div ref={ref}>
      <label className="block text-xs font-medium text-text-muted mb-1">Импортёр</label>
      <div className="relative">
        <input
          type="text"
          value={input}
          onChange={handleChange}
          onBlur={handleBlur}
          onFocus={() => suggestions.length > 0 && setShowSuggestions(true)}
          placeholder="напр. ТОВ"
          className="w-full px-2.5 py-1.5 text-sm bg-app text-text-primary placeholder:text-text-disabled border border-border-default rounded-lg
                     focus:outline-none focus:ring-1 focus:ring-ring-focus"
        />
        {showSuggestions && (
          <div className="absolute top-full left-0 right-0 mt-1 bg-elevated border border-border-default rounded-lg shadow-lg z-40 max-h-40 overflow-y-auto">
            {suggestions.map((s, i) => (
              <button
                key={i}
                onClick={() => handleSelect(s.importer_name)}
                className="w-full text-left px-3 py-1.5 text-sm hover:bg-blue-50 dark:hover:bg-blue-950/40 text-text-secondary flex justify-between"
              >
                <span className="truncate">{s.importer_name}</span>
                <span className="text-xs text-text-disabled ml-2 whitespace-nowrap">{s.count.toLocaleString('ru-RU')}</span>
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
